import React, { useState, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import Select from "react-select";
import Store from "../store/Store";
import Api from "../api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const customStyles = {
    control: (provided) => ({
        ...provided,
        border: "1px solid #ccc",
        backgroundColor: "white",
        "&:hover": {
            border: "1px solid #aaa"
        }
    })
};

const HarvestYearSelector = ({ show, onClose, harvestYears, actualHarvestYear }) => {
    const [selectedYear, setSelectedYear] = useState(actualHarvestYear || null);

    useEffect(() => {
        setSelectedYear(actualHarvestYear || null);
    }, [actualHarvestYear]);

    const handleChange = (selectedOption) => {
        setSelectedYear(selectedOption.value);
    };

    const saveSelection = async () => {
        if (selectedYear) {
            Api.IndexedDb().then((db) => {
                let actualHarvestYearStore = db.transaction("actualHarvestYear", "readwrite").objectStore("actualHarvestYear");
                actualHarvestYearStore.clear();
                actualHarvestYearStore.add({ id: selectedYear, value: selectedYear });
            });

            Store.dispatch({ type: "actualHarvestYear", value: selectedYear });
            Store.dispatch({ type: "loading", value: true });

            await Api.getTables();
            await Api.getTasks();

            Store.dispatch({ type: "loading", value: false });

            onClose(); // Bezárás
        }
    };

    const options = harvestYears.map((year) => ({ value: year.id, label: year.name }));

    return (
        <Offcanvas show={show} onHide={onClose} placement="end" backdrop={false} className="header-submenu">
            <Offcanvas.Body>
                <div className="page-head my-2 d-flex justify-content-between align-items-center">
                    <h2 className="title">Gazdaság</h2>
                    <button onClick={onClose} className="button btn close-menu">
                        <FontAwesomeIcon icon="fa-solid fa-chevron-left" /> Vissza
                    </button>
                </div>
                <div className="input-holder mt-4">
                    <label htmlFor="harvest-year-select">Aratási év</label>
                    <Select
                        styles={customStyles}
                        className="pwa-select-container"
                        classNamePrefix="pwa-select"
                        inputId="harvest-year-select"
                        value={options.find(option => option.value === selectedYear) || null}
                        options={options}
                        onChange={handleChange}
                    />
                </div>
                <button onClick={saveSelection} className="mt-3 button btn large">Mentés</button>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default HarvestYearSelector;
